import { usePastChallenges } from "../../api/hooks/past"
import { Page } from "../../components/@shared/page"
import { PastChallenges } from "../../components/past"

export default () => {
	const { loading, challenges, pagination } = usePastChallenges()

	return (
		<Page title='Past challenges'>
			<PastChallenges
				challenges={challenges}
				loading={loading}
				pagination={pagination}
			/>
		</Page>
	)
}
